module.exports = __webpack_public_path__ + "media/images/home/eat24-538604f20cb91e959f4c58aa0c90438e.png";